module.exports = __webpack_public_path__ + "static/media/bursts_15.21a86e4c.svg";